export const componentDefKey = 'ɵcmp';
export const factoryDefKey = 'ɵfac';
export const directiveDefKey = 'ɵdir';
